/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Coherent Labs AD. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import Dropzone from './lib_components/dropzone';
import IM from './utils/global-object';

IM.init();

export default Dropzone;
